/** Typography tokens aligned with website-cliqloan tailwind.config.js */
export const CLIQLOAN_TYPO = {
  fontFamily: "Inter, sans-serif",
  fontFamilyBold: "Inter, sans-serif",

  hero: {
    fontSize: "clamp(2rem, 4.1vw, 3.5rem)",
    lineHeight: 1.11,
    letterSpacing: "-0.048em",
  },
  section: {
    fontSize: "clamp(1.75rem, 3.12vw, 2.67rem)",
    lineHeight: 1.17,
    letterSpacing: "-0.048em",
  },
  cardTitle: {
    fontSize: "clamp(1rem, 1.45vw, 1.25rem)",
    lineHeight: 1.35,
    letterSpacing: "-0.048em",
    fontWeight: 700,
  },
  cardBody: {
    fontSize: "0.875rem",
    lineHeight: 1.55,
  },
  body: {
    fontSize: "clamp(0.875rem, 1.37vw, 1.17rem)",
    lineHeight: 1.5,
  },
  bodySm: {
    fontSize: "0.8125rem",
    lineHeight: 1.45,
  },
  nav: {
    fontSize: "clamp(1rem, 1.76vw, 1.5rem)",
    lineHeight: 1.08,
    letterSpacing: "-0.048em",
  },
  buttonSm: {
    fontSize: "clamp(0.75rem, 1.25vw, 1rem)",
    lineHeight: 1.17,
    letterSpacing: "0.045em",
  },
  pagePadding: "clamp(1.25rem, 5.62vw, 4.8rem)",
};

/** Compact carousel CTA — must fit narrow grid columns without clipping */
export const readMoreButtonSx = {
  backgroundColor: "#31b9b5",
  color: "#ffffff",
  border: "none",
  fontFamily: CLIQLOAN_TYPO.fontFamily,
  fontWeight: 600,
  fontSize: "0.6875rem",
  lineHeight: 1.2,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  minHeight: 30,
  py: 0.5,
  px: 1.25,
  width: "auto",
  maxWidth: "100%",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  borderRadius: "999px",
  "&:hover": {
    backgroundColor: "#2a9d99",
    color: "#ffffff",
    borderColor: "#2a9d99",
  },
};
